// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feature-one-sec {
  padding: 50px 0; /* add some padding to the section */
}

.feature-one__single {
  display: flex;
  flex-direction: column;
  align-items: center; /* center the content horizontally */
  padding: 20px; /* add some padding to the single feature container */
}

.feature-one__single-inner {
  max-width: 100%; /* limit the width of the inner container */
  margin: 0 auto; /* center the inner container horizontally */
}

.feature-one__single-text {
  font-size: 18px; /* set the font size for desktop view */
}

/* Tablet view (max-width: 768px) */
@media (max-width: 768px) {
  .feature-one__single-text {
    font-size: 10px; /* reduce font size for tablet view */
    text-align: justify;
  }
}

/* Mobile view (max-width: 480px) */
@media (max-width: 480px) {
  .feature-one__single-text {
    font-size: 9px; /* reduce font size for mobile view */
    text-align: justify;
  }
  .feature-one__single-inner {
    max-width: 100%; /* increase the width of the inner container for mobile view */
    text-align: justify;
  }
}

.feat-text {
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/features/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe,EAAE,oCAAoC;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,oCAAoC;EACzD,aAAa,EAAE,qDAAqD;AACtE;;AAEA;EACE,eAAe,EAAE,2CAA2C;EAC5D,cAAc,EAAE,4CAA4C;AAC9D;;AAEA;EACE,eAAe,EAAE,uCAAuC;AAC1D;;AAEA,mCAAmC;AACnC;EACE;IACE,eAAe,EAAE,qCAAqC;IACtD,mBAAmB;EACrB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,cAAc,EAAE,qCAAqC;IACrD,mBAAmB;EACrB;EACA;IACE,eAAe,EAAE,8DAA8D;IAC/E,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".feature-one-sec {\n  padding: 50px 0; /* add some padding to the section */\n}\n\n.feature-one__single {\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* center the content horizontally */\n  padding: 20px; /* add some padding to the single feature container */\n}\n\n.feature-one__single-inner {\n  max-width: 100%; /* limit the width of the inner container */\n  margin: 0 auto; /* center the inner container horizontally */\n}\n\n.feature-one__single-text {\n  font-size: 18px; /* set the font size for desktop view */\n}\n\n/* Tablet view (max-width: 768px) */\n@media (max-width: 768px) {\n  .feature-one__single-text {\n    font-size: 10px; /* reduce font size for tablet view */\n    text-align: justify;\n  }\n}\n\n/* Mobile view (max-width: 480px) */\n@media (max-width: 480px) {\n  .feature-one__single-text {\n    font-size: 9px; /* reduce font size for mobile view */\n    text-align: justify;\n  }\n  .feature-one__single-inner {\n    max-width: 100%; /* increase the width of the inner container for mobile view */\n    text-align: justify;\n  }\n}\n\n.feat-text {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
